import { Button, styled } from '@mui/material'

const StyledButton = styled(Button)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    color: '#0057A0 !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #0057A0',
    margin: 0,
    boxShadow: 'none',
    minWidth: '50px !important',
    padding: '8px 12px',
    lineHeight: 0,

    '&:hover': {
        color: '#ffffff !important',
        backgroundColor: '#0057A0 !important',
        borderColor: 'transparent !important',
    },
    ...props.styles,
}))

const ViewDetailsButton = ({ color, styles, children, ...rest }) => {
    return (
        <StyledButton size="small" styles={styles} {...rest}>
            {children}
        </StyledButton>
    )
}

export default ViewDetailsButton
